import { breakdownableConcept } from '@/returns/constants'
import { getItemsSum } from '@/returns/helpers/helpers'

const rejectedItemAmount = '0.00'

const getDiscountedAmount = (maxAmount, rejectedLineItemsAmount) => {
  return Math.max(parseFloat(maxAmount) - rejectedLineItemsAmount, 0).toFixed(2)
}

const getItemWithRejectionApplied = (item, rejectedLineItemIds) => {
  const amount = rejectedLineItemIds.includes(item.id) ? rejectedItemAmount : item.max_amount

  if (item.amount === amount) return item

  return { ...item, amount }
}

const getItemsWithRejectionApplied = (items, rejectedLineItemIds) => {
  if (!items?.length) return items

  const nextItems = items.map(item => getItemWithRejectionApplied(item, rejectedLineItemIds))

  if (nextItems.every((item, index) => item === items[index])) return items

  return nextItems
}

export const getConceptsWithRejectedItemsDiscount = ({
  concepts,
  productsMaxAmount,
  rejectedLineItemsAmount,
  rejectedLineItemIds,
}) => {
  if (!concepts?.length || !productsMaxAmount) return concepts

  const productsConcept = concepts.find(concept => concept.concept === breakdownableConcept)

  if (!productsConcept) return concepts

  const items = getItemsWithRejectionApplied(productsConcept.items, rejectedLineItemIds)
  const maxAmount = items?.length ? getItemsSum(items) : getDiscountedAmount(productsMaxAmount, rejectedLineItemsAmount)

  if (productsConcept.max_amount === maxAmount && items === productsConcept.items) return concepts

  return concepts.map(concept => {
    if (concept.concept !== breakdownableConcept) return concept

    return { ...concept, max_amount: maxAmount, amount: maxAmount, items }
  })
}

export const isProductsConceptDeselected = concepts => {
  const productsConcept = concepts?.find(concept => concept.concept === breakdownableConcept)

  if (!productsConcept) return false

  return !productsConcept.selected
}
